// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PrimeNG 19 Menubar Styles - Nav Component */
:host {
	display: block;
	width: 100%;
}

/* Main menubar container styling */
:host ::ng-deep #app-menubar .p-menubar {
	background: #27405f !important;
	border: none !important;
	border-radius: 0 !important;
	padding: 0 !important;
	min-height: 45px !important;
}

/* Horizontal root menu list */
:host ::ng-deep #app-menubar .p-menubar-root-list {
	display: flex !important;
	flex-direction: row !important;
	flex-wrap: wrap !important;
	align-items: center !important;
	margin: 0 !important;
	padding: 0 !important;
	list-style: none !important;
	gap: 0 !important;
}

/* Individual menu items */
:host ::ng-deep #app-menubar .p-menubar-root-list > .p-menubar-item,
:host ::ng-deep #app-menubar .p-menubar-root-list > li {
	display: inline-flex !important;
	position: relative !important;
}

/* Menu item content wrapper */
:host ::ng-deep #app-menubar .p-menubar-root-list > .p-menubar-item > .p-menubar-item-content,
:host ::ng-deep #app-menubar .p-menubar-root-list > li > .p-menubar-item-content {
	background: transparent !important;
	border: none !important;
	transition: background-color 0.2s ease !important;
}

/* Menu item link/anchor */
:host ::ng-deep #app-menubar .p-menubar-root-list > .p-menubar-item > .p-menubar-item-content > .p-menubar-item-link,
:host ::ng-deep #app-menubar .p-menubar-root-list > li > .p-menubar-item-content > .p-menubar-item-link {
	padding: 0.75rem 1.25rem !important;
	display: flex !important;
	align-items: center !important;
	text-decoration: none !important;
	color: white !important;
	cursor: pointer !important;
	background: transparent !important;
}

/* Hover state */
:host ::ng-deep #app-menubar .p-menubar-root-list > .p-menubar-item > .p-menubar-item-content:hover,
:host ::ng-deep #app-menubar .p-menubar-root-list > li > .p-menubar-item-content:hover {
	background-color: rgba(255, 255, 255, 0.15) !important;
}

/* Active/selected state */
:host ::ng-deep #app-menubar .p-menubar-root-list > .p-menubar-item.p-menubar-item-active > .p-menubar-item-content,
:host ::ng-deep #app-menubar .p-menubar-root-list > li.p-menubar-item-active > .p-menubar-item-content {
	background-color: #00095b !important;
}

/* Menu label text */
:host ::ng-deep #app-menubar .p-menubar-item-label {
	color: white !important;
	font-size: 14px !important;
	font-weight: 500 !important;
}

/* Submenu icon (dropdown arrow) */
:host ::ng-deep #app-menubar .p-menubar-submenu-icon {
	color: white !important;
	margin-left: 0.5rem !important;
}

/* ===== Legacy PrimeNG class support ===== */
:host ::ng-deep #app-menubar .p-menuitem {
	display: inline-flex !important;
}

:host ::ng-deep #app-menubar .p-menuitem-content {
	background: transparent !important;
	border: none !important;
}

:host ::ng-deep #app-menubar .p-menuitem-link {
	padding: 0.75rem 1.25rem !important;
	color: white !important;
	text-decoration: none !important;
}

:host ::ng-deep #app-menubar .p-menuitem-link:hover {
	background-color: rgba(255, 255, 255, 0.15) !important;
}

:host ::ng-deep #app-menubar .p-menuitem-text {
	color: white !important;
	font-size: 14px !important;
}

:host ::ng-deep #app-menubar .p-menuitem-icon {
	color: white !important;
	margin-right: 0.5rem !important;
}

/* ===== Submenu/Dropdown panel styling ===== */
:host ::ng-deep .p-menubar-submenu {
	background: #ffffff !important;
	border: 0 none !important;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
	border-radius: 4px !important;
	padding: 0.5rem 0 !important;
	min-width: 180px !important;
}

:host ::ng-deep .p-menubar-submenu .p-menubar-item > .p-menubar-item-content {
	background: transparent !important;
}

:host ::ng-deep .p-menubar-submenu .p-menubar-item > .p-menubar-item-content > .p-menubar-item-link {
	color: #495057 !important;
	padding: 0.75rem 1rem !important;
}

:host ::ng-deep .p-menubar-submenu .p-menubar-item > .p-menubar-item-content:hover {
	background: #e9ecef !important;
}

:host ::ng-deep .p-menubar-submenu .p-menubar-item > .p-menubar-item-content:hover > .p-menubar-item-link {
	color: #495057 !important;
}

:host ::ng-deep .p-menubar-submenu .p-menubar-item-label {
	color: #495057 !important;
}

/* ===== Mobile hamburger button ===== */
:host ::ng-deep #app-menubar .p-menubar-button {
	color: white !important;
	background: transparent !important;
	border: none !important;
	width: 2rem !important;
	height: 2rem !important;
	border-radius: 50% !important;
	transition: background-color 0.2s !important;
}

:host ::ng-deep #app-menubar .p-menubar-button:hover {
	background-color: rgba(255, 255, 255, 0.15) !important;
}

:host ::ng-deep #app-menubar .p-menubar-button:focus {
	outline: 0 none !important;
	box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25) !important;
}

/* ===== Sidebar Panel Menu (mobile) ===== */
:host ::ng-deep #app-sidebar .p-panelmenu .p-panelmenu-header > a {
	padding: 1rem !important;
	background: #f8f9fa !important;
	border: 1px solid #dee2e6 !important;
	color: #343a40 !important;
	font-weight: 600 !important;
}

:host ::ng-deep #app-sidebar .p-panelmenu .p-panelmenu-header > a:hover {
	background: #e9ecef !important;
}

:host ::ng-deep #app-sidebar .p-panelmenu .p-panelmenu-header.p-highlight > a {
	background: #27405f !important;
	color: #ffffff !important;
	border-color: #27405f !important;
}

:host ::ng-deep #app-sidebar .p-panelmenu .p-panelmenu-content .p-menuitem-link {
	padding: 0.75rem 1rem !important;
	color: #495057 !important;
}

:host ::ng-deep #app-sidebar .p-panelmenu .p-panelmenu-content .p-menuitem-link:hover {
	background: #e9ecef !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/nav/nav.component.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;CACC,cAAc;CACd,WAAW;AACZ;;AAEA,mCAAmC;AACnC;CACC,8BAA8B;CAC9B,uBAAuB;CACvB,2BAA2B;CAC3B,qBAAqB;CACrB,2BAA2B;AAC5B;;AAEA,8BAA8B;AAC9B;CACC,wBAAwB;CACxB,8BAA8B;CAC9B,0BAA0B;CAC1B,8BAA8B;CAC9B,oBAAoB;CACpB,qBAAqB;CACrB,2BAA2B;CAC3B,iBAAiB;AAClB;;AAEA,0BAA0B;AAC1B;;CAEC,+BAA+B;CAC/B,6BAA6B;AAC9B;;AAEA,8BAA8B;AAC9B;;CAEC,kCAAkC;CAClC,uBAAuB;CACvB,iDAAiD;AAClD;;AAEA,0BAA0B;AAC1B;;CAEC,mCAAmC;CACnC,wBAAwB;CACxB,8BAA8B;CAC9B,gCAAgC;CAChC,uBAAuB;CACvB,0BAA0B;CAC1B,kCAAkC;AACnC;;AAEA,gBAAgB;AAChB;;CAEC,sDAAsD;AACvD;;AAEA,0BAA0B;AAC1B;;CAEC,oCAAoC;AACrC;;AAEA,oBAAoB;AACpB;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA,kCAAkC;AAClC;CACC,uBAAuB;CACvB,8BAA8B;AAC/B;;AAEA,6CAA6C;AAC7C;CACC,+BAA+B;AAChC;;AAEA;CACC,kCAAkC;CAClC,uBAAuB;AACxB;;AAEA;CACC,mCAAmC;CACnC,uBAAuB;CACvB,gCAAgC;AACjC;;AAEA;CACC,sDAAsD;AACvD;;AAEA;CACC,uBAAuB;CACvB,0BAA0B;AAC3B;;AAEA;CACC,uBAAuB;CACvB,+BAA+B;AAChC;;AAEA,+CAA+C;AAC/C;CACC,8BAA8B;CAC9B,yBAAyB;CACzB,sDAAsD;CACtD,6BAA6B;CAC7B,4BAA4B;CAC5B,2BAA2B;AAC5B;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,yBAAyB;CACzB,gCAAgC;AACjC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,wCAAwC;AACxC;CACC,uBAAuB;CACvB,kCAAkC;CAClC,uBAAuB;CACvB,sBAAsB;CACtB,uBAAuB;CACvB,6BAA6B;CAC7B,4CAA4C;AAC7C;;AAEA;CACC,sDAAsD;AACvD;;AAEA;CACC,0BAA0B;CAC1B,6DAA6D;AAC9D;;AAEA,4CAA4C;AAC5C;CACC,wBAAwB;CACxB,8BAA8B;CAC9B,oCAAoC;CACpC,yBAAyB;CACzB,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;CAC9B,yBAAyB;CACzB,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;CAChC,yBAAyB;AAC1B;;AAEA;CACC,8BAA8B;AAC/B","sourcesContent":["/* PrimeNG 19 Menubar Styles - Nav Component */\n:host {\n\tdisplay: block;\n\twidth: 100%;\n}\n\n/* Main menubar container styling */\n:host ::ng-deep #app-menubar .p-menubar {\n\tbackground: #27405f !important;\n\tborder: none !important;\n\tborder-radius: 0 !important;\n\tpadding: 0 !important;\n\tmin-height: 45px !important;\n}\n\n/* Horizontal root menu list */\n:host ::ng-deep #app-menubar .p-menubar-root-list {\n\tdisplay: flex !important;\n\tflex-direction: row !important;\n\tflex-wrap: wrap !important;\n\talign-items: center !important;\n\tmargin: 0 !important;\n\tpadding: 0 !important;\n\tlist-style: none !important;\n\tgap: 0 !important;\n}\n\n/* Individual menu items */\n:host ::ng-deep #app-menubar .p-menubar-root-list > .p-menubar-item,\n:host ::ng-deep #app-menubar .p-menubar-root-list > li {\n\tdisplay: inline-flex !important;\n\tposition: relative !important;\n}\n\n/* Menu item content wrapper */\n:host ::ng-deep #app-menubar .p-menubar-root-list > .p-menubar-item > .p-menubar-item-content,\n:host ::ng-deep #app-menubar .p-menubar-root-list > li > .p-menubar-item-content {\n\tbackground: transparent !important;\n\tborder: none !important;\n\ttransition: background-color 0.2s ease !important;\n}\n\n/* Menu item link/anchor */\n:host ::ng-deep #app-menubar .p-menubar-root-list > .p-menubar-item > .p-menubar-item-content > .p-menubar-item-link,\n:host ::ng-deep #app-menubar .p-menubar-root-list > li > .p-menubar-item-content > .p-menubar-item-link {\n\tpadding: 0.75rem 1.25rem !important;\n\tdisplay: flex !important;\n\talign-items: center !important;\n\ttext-decoration: none !important;\n\tcolor: white !important;\n\tcursor: pointer !important;\n\tbackground: transparent !important;\n}\n\n/* Hover state */\n:host ::ng-deep #app-menubar .p-menubar-root-list > .p-menubar-item > .p-menubar-item-content:hover,\n:host ::ng-deep #app-menubar .p-menubar-root-list > li > .p-menubar-item-content:hover {\n\tbackground-color: rgba(255, 255, 255, 0.15) !important;\n}\n\n/* Active/selected state */\n:host ::ng-deep #app-menubar .p-menubar-root-list > .p-menubar-item.p-menubar-item-active > .p-menubar-item-content,\n:host ::ng-deep #app-menubar .p-menubar-root-list > li.p-menubar-item-active > .p-menubar-item-content {\n\tbackground-color: #00095b !important;\n}\n\n/* Menu label text */\n:host ::ng-deep #app-menubar .p-menubar-item-label {\n\tcolor: white !important;\n\tfont-size: 14px !important;\n\tfont-weight: 500 !important;\n}\n\n/* Submenu icon (dropdown arrow) */\n:host ::ng-deep #app-menubar .p-menubar-submenu-icon {\n\tcolor: white !important;\n\tmargin-left: 0.5rem !important;\n}\n\n/* ===== Legacy PrimeNG class support ===== */\n:host ::ng-deep #app-menubar .p-menuitem {\n\tdisplay: inline-flex !important;\n}\n\n:host ::ng-deep #app-menubar .p-menuitem-content {\n\tbackground: transparent !important;\n\tborder: none !important;\n}\n\n:host ::ng-deep #app-menubar .p-menuitem-link {\n\tpadding: 0.75rem 1.25rem !important;\n\tcolor: white !important;\n\ttext-decoration: none !important;\n}\n\n:host ::ng-deep #app-menubar .p-menuitem-link:hover {\n\tbackground-color: rgba(255, 255, 255, 0.15) !important;\n}\n\n:host ::ng-deep #app-menubar .p-menuitem-text {\n\tcolor: white !important;\n\tfont-size: 14px !important;\n}\n\n:host ::ng-deep #app-menubar .p-menuitem-icon {\n\tcolor: white !important;\n\tmargin-right: 0.5rem !important;\n}\n\n/* ===== Submenu/Dropdown panel styling ===== */\n:host ::ng-deep .p-menubar-submenu {\n\tbackground: #ffffff !important;\n\tborder: 0 none !important;\n\tbox-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;\n\tborder-radius: 4px !important;\n\tpadding: 0.5rem 0 !important;\n\tmin-width: 180px !important;\n}\n\n:host ::ng-deep .p-menubar-submenu .p-menubar-item > .p-menubar-item-content {\n\tbackground: transparent !important;\n}\n\n:host ::ng-deep .p-menubar-submenu .p-menubar-item > .p-menubar-item-content > .p-menubar-item-link {\n\tcolor: #495057 !important;\n\tpadding: 0.75rem 1rem !important;\n}\n\n:host ::ng-deep .p-menubar-submenu .p-menubar-item > .p-menubar-item-content:hover {\n\tbackground: #e9ecef !important;\n}\n\n:host ::ng-deep .p-menubar-submenu .p-menubar-item > .p-menubar-item-content:hover > .p-menubar-item-link {\n\tcolor: #495057 !important;\n}\n\n:host ::ng-deep .p-menubar-submenu .p-menubar-item-label {\n\tcolor: #495057 !important;\n}\n\n/* ===== Mobile hamburger button ===== */\n:host ::ng-deep #app-menubar .p-menubar-button {\n\tcolor: white !important;\n\tbackground: transparent !important;\n\tborder: none !important;\n\twidth: 2rem !important;\n\theight: 2rem !important;\n\tborder-radius: 50% !important;\n\ttransition: background-color 0.2s !important;\n}\n\n:host ::ng-deep #app-menubar .p-menubar-button:hover {\n\tbackground-color: rgba(255, 255, 255, 0.15) !important;\n}\n\n:host ::ng-deep #app-menubar .p-menubar-button:focus {\n\toutline: 0 none !important;\n\tbox-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25) !important;\n}\n\n/* ===== Sidebar Panel Menu (mobile) ===== */\n:host ::ng-deep #app-sidebar .p-panelmenu .p-panelmenu-header > a {\n\tpadding: 1rem !important;\n\tbackground: #f8f9fa !important;\n\tborder: 1px solid #dee2e6 !important;\n\tcolor: #343a40 !important;\n\tfont-weight: 600 !important;\n}\n\n:host ::ng-deep #app-sidebar .p-panelmenu .p-panelmenu-header > a:hover {\n\tbackground: #e9ecef !important;\n}\n\n:host ::ng-deep #app-sidebar .p-panelmenu .p-panelmenu-header.p-highlight > a {\n\tbackground: #27405f !important;\n\tcolor: #ffffff !important;\n\tborder-color: #27405f !important;\n}\n\n:host ::ng-deep #app-sidebar .p-panelmenu .p-panelmenu-content .p-menuitem-link {\n\tpadding: 0.75rem 1rem !important;\n\tcolor: #495057 !important;\n}\n\n:host ::ng-deep #app-sidebar .p-panelmenu .p-panelmenu-content .p-menuitem-link:hover {\n\tbackground: #e9ecef !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
